<template>
  <div class="ol-map">
    <!-- 天地图标注 -->
    <ol-layer-tile
      name="mark"
      type="basemap"
      :zIndex="10"
      :visible="showTianMark && basemap === 'tianmap'"
    >
      <ol-source-xyz
        url="http://t{0-7}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=95b976bf1c852b261315ac5bcd2c3955"
      ></ol-source-xyz>
    </ol-layer-tile>

    <!-- 底图 -->
    <ol-layer-tile name="imagery">
      <ol-source-xyz :url="basemapUrl"></ol-source-xyz>
    </ol-layer-tile>

    <!-- 绘面、测距、测面 -->
    <ol-draw v-bind="drawOption" @drawend="(wkt) => $emit('drawend', wkt)" />

    <!-- 地图工具 -->
    <div
      class="ol-map-tools slide-in-right"
      :style="toolPosition"
      v-if="toolbarShow"
    >
      <div class="ol-map-tool-group">
        <!-- <div class="ol-map-tool" @click="onDraw({ active: true, type: undefined, measure: false })">
          <el-tooltip class="item" effect="dark" content="绘面" placement="left">
            <svg-icon icon-name="polygon" icon-class="ol-map-tool-icon"></svg-icon>
          </el-tooltip>
        </div> -->

        <div
          class="ol-map-tool"
          @click="onDraw({ active: true, type: 'LineString', measure: true })"
        >
          <el-tooltip
            popper-class="my-custom-tooltip"
            class="item"
            effect="dark"
            content="测距"
            placement="left"
          >
            <svg-icon
              icon-name="length"
              icon-class="ol-map-tool-icon"
            ></svg-icon>
          </el-tooltip>
        </div>

        <div
          class="ol-map-tool"
          @click="onDraw({ active: true, type: 'Polygon', measure: true })"
        >
          <el-tooltip
            popper-class="my-custom-tooltip"
            class="item"
            effect="dark"
            content="测面"
            placement="left"
          >
            <svg-icon
              icon-name="ce_area"
              style="font-size: 16px"
              icon-class="ol-map-tool-icon"
            ></svg-icon>
          </el-tooltip>
        </div>

        <div class="ol-map-tool" @click="onDraw({ active: false })">
          <el-tooltip
            popper-class="my-custom-tooltip"
            class="item"
            effect="dark"
            content="清空"
            placement="left"
          >
            <svg-icon
              icon-name="clear"
              icon-class="ol-map-tool-icon"
            ></svg-icon>
          </el-tooltip>
        </div>
      </div>

      <div class="ol-map-tool-group m-t-sm">
        <div class="ol-map-tool" v-click-outside="() => (showLayer = false)">
          <el-tooltip
            popper-class="my-custom-tooltip"
            class="item"
            effect="dark"
            content="图层"
            placement="left"
          >
            <svg-icon
              icon-name="layer"
              icon-class="ol-map-tool-icon"
              @click.native="getLayers"
            ></svg-icon>
          </el-tooltip>

          <transition
            enter-active-class="slide-in-right"
            leave-active-class="slide-out-right"
          >
            <div class="ol-map-layers" v-if="showLayer">
              <div
                class="ol-map-layer"
                :class="{ visible: item.visible }"
                v-for="item in layers"
                :key="item.id"
                @click="layerToggle(item)"
              >
                <svg-icon :icon-name="item.visible ? 'show' : 'hidden'" />{{
                  item.name
                }}
              </div>
            </div>
          </transition>
        </div>

        <div class="ol-map-tool" v-if="showBtns">
          <el-tooltip
            popper-class="my-custom-tooltip"
            class="item"
            effect="dark"
            content="截图"
            placement="left"
          >
            <svg-icon
              icon-name="screenshot"
              icon-class="ol-map-tool-icon"
              @click.native="onExportMap"
            ></svg-icon>
          </el-tooltip>

          <transition
            enter-active-class="slide-in-right"
            leave-active-class="slide-out-right"
          >
            <div class="crop-images" v-if="imageData.length > 0">
              <div class="crop-image-title">
                <span
                  ><svg-icon
                    icon-name="screenshot"
                    icon-class="m-r-xs"
                  />截图列表</span
                >
                <el-button class="m-l-auto" size="mini" @click="onConflate"
                  >合成</el-button
                >
              </div>
              <el-scrollbar class="crop-scrollbar">
                <div class="crop-image-box">
                  <div
                    class="crop-image-item"
                    v-for="(item, index) in imageData"
                    :key="index"
                  >
                    <el-image
                      class="crop-image"
                      :src="item.data"
                      :preview-src-list="imageData.map((item) => item.data)"
                    />
                    <i
                      class="remove-image el-icon-delete"
                      @click="onRemoveImage(index)"
                    ></i>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </transition>
        </div>

        <div
          class="ol-map-tool"
          v-if="showBtns && timelines.length > 0 && rollerShow"
        >
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="卷帘"
            placement="left"
          >
            <svg-icon
              icon-name="swipe"
              icon-class="ol-map-tool-icon"
              @click.native="onShowSwip"
            ></svg-icon>
          </el-tooltip>
        </div>

        <div
          class="ol-map-tool"
          v-if="showBtns && timelines.length > 1 && rollerShow"
        >
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="对比"
            placement="left"
          >
            <svg-icon
              icon-name="shared"
              icon-class="ol-map-tool-icon"
              @click.native="showShared = true"
            ></svg-icon>
          </el-tooltip>
        </div>
      </div>

      <!-- <div class="ol-map-tool-group m-t-sm"> -->

      <!-- <div class="ol-map-tool" v-click-outside="() => showBasemap = false">
          <el-tooltip class="item" popper-class="my-custom-tooltip" effect="dark" content="底图" placement="left">
            <svg-icon icon-name="basemap" icon-class="ol-map-tool-icon"
              @click.native="showBasemap = !showBasemap"></svg-icon>
          </el-tooltip>

          <transition enter-active-class="slide-in-right" leave-active-class="slide-out-right">
            <div class="ol-map-switch-basemap" v-show="showBasemap">
              <div class="ol-map-basemap" v-for="item in basemaps" :key="item.name"
                :class="{ active: basemap === item.name }" @click="basemap = item.name">
                <div class="ol-map-basemap-mark" v-show="item.name === 'tianmap' && basemap === 'tianmap'"
                  @click.stop="showTianMark = !showTianMark">
                  <span class="ol-map-basemap-mark-label" :class="{ selected: showTianMark }">地名</span>
                </div>
                <img class="ol-map-basemap-img" :src="require(`./images/${item.name}.jpg`)" :alt="item.label" />
                <div class="ol-map-basemap-label">
                  <span>{{ item.label }}</span>
                </div>
              </div>
            </div>
          </transition>
        </div> -->

      <!-- <div class="ol-map-tool" v-show="zones.length > 0" v-click-outside="() => showZone = false">
          <el-tooltip class="item" effect="dark" popper-class="my-custom-tooltip" content="区域" placement="left">
            <svg-icon icon-name="zone" icon-class="ol-map-tool-icon" @click.native="showZone = !showZone"></svg-icon>
          </el-tooltip>

          <transition enter-active-class="slide-in-right" leave-active-class="slide-out-right">
            <div class="ol-map-layers" v-if="showZone">
              <div class="ol-map-layer" :class="{ visible: item.visible }" v-for="item in zones" :key="item.id"
                @click="switchZone(item)">
                <svg-icon :icon-name="item.visible ? 'show' : 'hidden'" />{{ item.name }}
              </div>
            </div>
          </transition>
        </div> -->
      <!-- </div> -->

      <div class="ol-map-tool-group m-t-sm">
        <div class="ol-map-tool" @click="onChangeView('reset')">
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="复位"
            placement="left"
          >
            <svg-icon
              icon-name="reset"
              icon-class="ol-map-tool-icon"
            ></svg-icon>
          </el-tooltip>
        </div>
        <div class="ol-map-tool" @click="onChangeView('zoomIn')">
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="放大"
            placement="left"
          >
            <svg-icon
              icon-name="zoom-in"
              icon-class="ol-map-tool-icon"
            ></svg-icon>
          </el-tooltip>
        </div>
        <div class="ol-map-tool" @click="onChangeView('zoomOut')">
          <el-tooltip
            class="item"
            popper-class="my-custom-tooltip"
            effect="dark"
            content="缩小"
            placement="left"
          >
            <svg-icon
              icon-name="zoom-out"
              icon-class="ol-map-tool-icon"
            ></svg-icon>
          </el-tooltip>
        </div>
      </div>

      <div class="ol-map-tool-slot">
        <slot name="tools"></slot>
      </div>
    </div>

    <!-- 鼠标位置 -->
    <div
      id="mouse-position"
      v-if="toolbarShow"
      class="ol-map-mouse-position slide-in-left"
    ></div>
    <!-- 渐变图例 -->
    <transition
      enter-active-class="slide-in-right"
      leave-active-class="slide-out-right"
    >
      <div
        class="ol-map-legends gradient-box"
        :style="rightPosition"
        v-if="gradientLegends.length > 0"
      >
        <div
          style="
            color: #fff;
            font-size: 14px;
            margin-bottom: 5px;
            text-align: center;
          "
        >
          {{ sortDatasetName || datasetName }}
          <span v-if="datasetUnit">({{ datasetUnit }})</span>
        </div>
        <div style="display: flex; justify-content: center">
          <div style="display: flex">
            <div
              class="gradient-line"
              :style="{ background: caclGradient() }"
            ></div>
            <div class="label_box">
              <div class="ol-map-legend-label">
                {{ gradientLegends[gradientLegends.length - 1].labelText }}
              </div>
              <div class="ol-map-legend-label">
                {{ gradientLegends[0].labelText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 图例 -->
    <transition
      enter-active-class="slide-in-right"
      leave-active-class="slide-out-right"
    >
      <div
        class="ol-map-legends"
        :style="rightPosition"
        v-show="legends.length > 0"
      >
        <div class="legendTitle" v-if="datasetUnit">
          {{ datasetName }}({{ datasetUnit }})
        </div>
        <div class="legendTitle" v-else>图例</div>

        <div class="legendBigBox">
          <div class="ol-map-legend" v-for="item in legends" :key="item.id">
            <div
              class="ol-map-legend-icon"
              :style="{ backgroundColor: item.color }"
            ></div>
            <div class="ol-map-legend-label">{{ item.labelText }}</div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 图标图例 -->
    <transition
      enter-active-class="slide-in-right"
      leave-active-class="slide-out-right"
    >
      <div
        class="ol-map-legends"
        :style="rightPosition"
        v-show="iconLegends.length > 0"
      >
        <div class="legendTitle">图例</div>
        <div class="legendBigBox">
          <div class="ol-map-legend" v-for="item in iconLegends" :key="item.id">
            <div class="ol-map-legend-icon iconUrl">
              <img :src="item.src" alt="" />
            </div>
            <div class="ol-map-legend-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 时间轴 -->
    <ol-timeline
      ref="olTimeline"
      :timelines="timelines"
      @change="onTimelineChange"
    ></ol-timeline>

    <!-- 卷帘 -->

    <div class="ol-map-dialog" v-if="showSwip">
      <div class="ol-map-dialog-main">
        <svg-icon
          icon-name="close_"
          icon-class="close-btn pointer"
          @click.native="showSwip = false"
        ></svg-icon>
        <div class="ol-map-dialog-title">数据对比</div>
        <ol-swipe
          class="mySwipe"
          :projectValue="projectValue"
          :extent="extent"
          :legends="legends"
          :unit="unit"
          :timeline="timeline"
        />
      </div>
    </div>

    <!-- 比对 -->

    <div class="ol-map-dialog" v-if="showShared">
      <div class="ol-map-dialog-main">
        <svg-icon
          icon-name="close_"
          icon-class="close-btn pointer"
          @click.native="showShared = false"
        ></svg-icon>
        <div class="ol-map-dialog-title">数据对比</div>
        <ol-shared
          :legends="legends"
          :projectValue="projectValue"
          :extent="extent"
          :unit="unit"
          :timelines="timelines"
        />
      </div>
    </div>

    <slot></slot>

    <div class="screen-image" v-if="cropOption.img !== ''">
      <vueCropper
        ref="cropper"
        v-bind="cropOption"
        @imgLoad="onImgLoad"
        style="background-image: none"
      />
      <div class="screen-operate">
        <el-input
          class="text-center m-r-sm"
          v-model="cropOption.autoCropWidth"
          style="width: 120px"
        ></el-input>
        <el-input
          class="text-center m-r-sm"
          v-model="cropOption.autoCropHeight"
          style="width: 120px"
        ></el-input>
        <el-button @click="onCancelCrop">取消</el-button>
        <el-button @click="onConfirmCrop">截取</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import GIF from "@dhdbstjr98/gif.js";
import "ol/ol.css";
import Map from "ol/Map";
import { format } from "ol/coordinate";
import { defaults as defaultControls, MousePosition } from "ol/control";
import { defaults as defaultInteractions } from "ol/interaction";
import OlTimeline from "./components/ol-timeline";
import OlSwipe from "./components/ol-swipe";
import OlShared from "./components/ol-shared";
import { getCustomRegion } from "@/api/common";

export default {
  name: "ol-map",

  components: {
    OlTimeline,
    OlSwipe,
    OlShared,
  },

  provide() {
    return {
      getMap: this.getMap,
    };
  },

  props: {
    // 是否显示缩放按钮
    zoom: {
      type: Boolean,
      default: false,
    },
    projectValue: {
      type: String,
      default: "",
    },
    extent: {
      type: [Array, String],
      default: "",
    },
    // 旋转按钮
    rotate: {
      type: Boolean,
      default: false,
    },

    // 双击放大地图
    doubleClickZoom: {
      type: Boolean,
      default: false,
    },
    // 卷帘是否显示
    rollerShow: {
      type: Boolean,
      default: true,
    },
    datasetName: {
      type: String,
      default: "",
    },
    sortDatasetName: {
      type: String,
      default: "",
    },
    datasetUnit: {
      type: String,
      default: "",
    },
    toolPosition: {
      type: Object,
      default() {
        return {
          top: "10px",
          right: "10px",
        };
      },
    },

    // 图例单位
    unit: {
      type: String,
      default: "万亩",
    },

    // 图例
    // 数据结构：[{ id: 1, label: '很好', color: '#10F500', selected: true }]
    legends: {
      type: Array,
      default: () => [],
    },
    gradientLegends: {
      type: Array,
      default: () => [],
    },
    //图标图例
    iconLegends: {
      type: Array,
      default: () => [],
    },
    // 时间轴
    // 数据结构：[{ id: 1, label: '2023-03-06', layer: require('@/assets/images/layer.png') }]
    timelines: {
      type: Array,
      required: true,
    },
    toolbarShow: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    basemapUrl() {
      const { url } = this.basemaps.find((item) => item.name === this.basemap);
      return url;
    },

    showBtns() {
      // return this.$route.meta.module !== 'meteorsdk'
      return true;
    },
  },

  watch: {
    "$route.query.regionId": {
      async handler(newVal) {
        // this.zones = await getCustomRegion(newVal)
      },
      immediate: true,
    },

    timelines: {
      handler(newVal) {
        this.currentDate = newVal.length > 0 ? newVal[0].productTimeCn : "";
      },
      immediate: true,
    },
  },

  data() {
    return {
      rightPosition: { right: "7%" },
      map: null,
      // 是否显示底图选择框
      showBasemap: false,
      showZone: false,
      // 自定义区域
      zones: [],
      // 所有底图
      basemaps: [
        {
          id: 1,
          name: "tianmap",
          label: "天地图",
          url: "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=95b976bf1c852b261315ac5bcd2c3955",
        },
        {
          id: 2,
          name: "blue-black",
          label: "蓝黑版",
          url: "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}",
        },
        {
          id: 3,
          name: "multi-color",
          label: "彩色版",
          url: "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer/tile/{z}/{y}/{x}",
        },
        {
          id: 4,
          name: "warm",
          label: "暖色版",
          url: "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetWarm/MapServer/tile/{z}/{y}/{x}",
        },
        {
          id: 5,
          name: "grey",
          label: "灰色版",
          url: "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}",
        },
        // { id: 6, name: 'gaode', label: 'gaode', url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&style=6' }
      ],
      // 底图
      basemap: "tianmap",
      // 是否显示天地图注记
      showTianMark: false,
      // 是否选中所有图例
      legendAll: true,
      drawOption: {
        // 是否激活绘制功能
        active: false,
        // 绘制形状
        type: "Polygon",
        // 是否测量
        measure: true,
      },
      layers: [],
      showLayer: false,
      showSwip: false,
      showShared: false,
      timeline: null,
      cropOption: {
        // 要裁剪的图片
        img: "",
        // 裁剪框的大小信息
        info: true,
        // 裁剪生成图片的质量
        outputSize: 0.8,
        // 裁剪生成图片的格式
        outputType: "png",
        // 图片是否允许滚轮缩放
        canScale: false,
        // 是否允许拖动图片
        canMove: false,
        // 是否默认生成截图框
        autoCrop: true,
        // 默认截图框宽度
        autoCropWidth: 560,
        // 默认截图框高度
        autoCropHeight: 540,
        // 固定截图框大小 不允许改变
        fixedBox: false,
        // 截图框是否限制在图片内
        centerBox: true,
        // 是否输出原图比例的截图
        full: true,
      },
      currentDate: "",
      imageData: [],
    };
  },

  created() {
    this.map = new Map({
      controls: defaultControls({
        zoom: this.zoom,
        rotate: this.rotate,
      }),
      interactions: defaultInteractions({
        doubleClickZoom: this.doubleClickZoom,
      }),
    });
  },

  mounted() {
    this.resize();
    window.addEventListener("resize", this.resize);
    if (this.toolbarShow) {
      const mousePositionControl = new MousePosition({
        coordinateFormat(coordinate) {
          document.getElementById("mouse-position").style.display = "flex";
          return format(coordinate, "&emsp;经度: {x} 纬度: {y}&emsp;", 2);
        },
        projection: "EPSG:4326",
        className: "ol-map-mouse-position",
        target: document.getElementById("mouse-position"),
        placeholder: false,
        undefinedHTML: "",
      });
      this.map.addControl(mousePositionControl);
    }
    this.map.setTarget(this.$el);
    // 注册事件
    this.bindClick();
  },

  methods: {
    caclGradient() {
      let str = "linear-gradient(to bottom,";
      this.gradientLegends.forEach((v, i) => {
        if (i === this.gradientLegends.length - 1) {
          str += `${v.color} ${
            (i / (this.gradientLegends.length - 1)) * 100
          }% )`;
        } else {
          str += `${v.color} ${
            (i / (this.gradientLegends.length - 1)) * 100
          }%, `;
        }
      });
      return str;
    },
    resize() {
      const height = window.innerHeight;
      if (height < 800) {
        this.rightPosition = { right: "56px" };
      } else {
        this.rightPosition = { right: "6%" };
      }
    },

    // 获取组件实例
    getMap(cb) {
      // const checkForMap = () => {
      //   if (this.map) {
      //     cb(this.map)
      //   } else {
      //     setTimeout(checkForMap, 50)
      //   }
      // }
      // checkForMap()
      cb(this.map);
    },

    onTimelineChange(current) {
      this.$emit("timelineChange", current);
      this.currentDate = current.text;
    },

    onExportMap() {
      this.map.once("rendercomplete", () => {
        const mapCanvas = document.createElement("canvas");
        const size = this.map.getSize();
        mapCanvas.width = size[0];
        mapCanvas.height = size[1];
        const mapContext = mapCanvas.getContext("2d");
        Array.prototype.forEach.call(
          this.map
            .getViewport()
            .querySelectorAll(".stamen canvas, canvas.stamen"),
          function (canvas) {
            if (canvas.width > 0) {
              const opacity =
                canvas.parentNode.style.opacity || canvas.style.opacity;
              mapContext.globalAlpha = opacity === "" ? 1 : Number(opacity);

              const backgroundColor = canvas.parentNode.style.backgroundColor;
              if (backgroundColor) {
                mapContext.fillStyle = backgroundColor;
                mapContext.fillRect(0, 0, canvas.width, canvas.height);
              }

              let matrix;
              const transform = canvas.style.transform;
              if (transform) {
                // Get the transform parameters from the style's transform matrix
                matrix = transform
                  .match(/^matrix\(([^\\(]*)\)$/)[1]
                  .split(",")
                  .map(Number);
              } else {
                matrix = [
                  parseFloat(canvas.style.width) / canvas.width,
                  0,
                  0,
                  parseFloat(canvas.style.height) / canvas.height,
                  0,
                  0,
                ];
              }
              // Apply the transform to the export map context
              CanvasRenderingContext2D.prototype.setTransform.apply(
                mapContext,
                matrix
              );
              mapContext.drawImage(canvas, 0, 0);
            }
          }
        );
        mapContext.globalAlpha = 1;
        this.cropOption.img = mapCanvas.toDataURL();
      });
      this.map.renderSync();
    },

    // 删除指定截图
    onRemoveImage(index) {
      this.imageData.splice(index, 1);
    },

    onImgLoad(state) {
      if (state === "success") {
        // 重新生成自动裁剪框
        this.$refs.cropper.goAutoCrop();
        this.$nextTick(() => {
          if (sessionStorage.getItem("x1")) {
            const cropper = this.$refs.cropper;
            cropper.cropOffsertX = Number(sessionStorage.getItem("x1"));
            cropper.cropOffsertY = Number(sessionStorage.getItem("y1"));
            this.cropOption.autoCropWidth = Number(sessionStorage.getItem("w"));
            this.cropOption.autoCropHeight = Number(
              sessionStorage.getItem("h")
            );
          }
        });
      }
    },

    // 取消截图
    onCancelCrop() {
      this.cropOption.img = "";
    },

    // 确认截图
    onConfirmCrop() {
      const cropper = this.$refs.cropper;
      // getCropData 获取截图的 base64 格式数据
      // getCropBlob 获取截图的 Blob 格式数据
      cropper.getCropData((data) => {
        this.imageData.push({ data, date: this.currentDate });
        this.cropOption.img = "";
        const { x1, y1 } = cropper.getCropAxis();
        sessionStorage.setItem("x1", x1);
        sessionStorage.setItem("y1", y1);
        sessionStorage.setItem("w", cropper.cropW);
        sessionStorage.setItem("h", cropper.cropH);
      });
    },

    // 合成 GIF
    onConflate() {
      const gif = new GIF({
        workers: 2,
        quality: 10,
      });
      const loadPromise = this.imageData.map(this.loadImage);
      Promise.all(loadPromise)
        .then((images) => {
          // 遍历所有图片并将其添加到GIF实例中
          images.forEach((image) => {
            // 每帧的延迟时间为 200 毫秒
            gif.addFrame(image, { delay: 500 });
          });

          // 完成合成并导出GIF动画
          gif.on("finished", (blob) => {
            // window.open(URL.createObjectURL(blob))
            // 创建一个链接并设置下载属性
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${this.$route.meta.title}.gif`;
            link.click();
            this.imageData = [];
            // 清理链接对象
            URL.revokeObjectURL(url);
          });

          // 启动GIF合成过程
          gif.render();
        })
        .catch(function (error) {
          console.error("加载图片失败:", error);
        });
    },

    // 加载图片
    loadImage(payload) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          const text = this.$route.meta.title;
          ctx.drawImage(image, 0, 0);
          // 绘制文字
          // 设置字体样式和大小
          ctx.font = "bolder 30px Arial";
          // 设置文字颜色
          ctx.fillStyle = "#fff";
          // 计算文字的宽度
          const textWidth = ctx.measureText(text).width;
          // 计算水平居中的位置
          const x = (canvas.width - textWidth) / 2;
          // 使用fillText()方法绘制填充文字
          ctx.fillText(text, x, 40);
          ctx.fillText(payload.date, 20, canvas.height - 20);
          resolve(canvas);
        };
        image.onerror = function () {
          reject(new Error("加载图片失败: " + payload.data));
        };
        image.src = payload.data;
      });
    },

    // 地图点击处理函数
    clickHandle(e) {
      if (!e.dragging) {
        this.$emit("click", {
          evt: e,
          features: e.map.getFeaturesAtPixel(e.pixel),
          map: this.map,
        });
      }
    },

    bindClick() {
      this.map.on(["singleclick", "dblclick"], this.clickHandle);
    },

    unBindClick() {
      this.map.un(["singleclick", "dblclick"], this.clickHandle);
    },

    // 绘面、测量
    onDraw(payload) {
      this.drawOption = payload;
      // this.unBindClick();
    },

    // 全选、反选图例
    onLegendToggle() {
      this.legendAll = !this.legendAll;
      this.legends.forEach((item) => {
        item.selected = this.legendAll;
      });
      this.$emit(
        "legendChange",
        this.legends.filter((item) => item.selected)
      );
    },

    // 切换单个图例
    onLegendClick(payload) {
      payload.selected = !payload.selected;
      const data = this.legends.filter((item) => item.selected);
      if (data.length === this.legends.length) {
        this.legendAll = true;
      }
      if (data.length === 0) {
        this.legendAll = false;
      }
      this.$emit("legendChange", data);
    },

    // 缩放、复位
    onChangeView(type) {
      const view = this.$children.find(
        (item) => item.$options.name === "ol-view"
      );
      view[type]();
    },

    // 获取所有图层
    getLayers() {
      const layers = this.map.getLayers();
      const layerList = [];
      for (let i = 0, j = layers.getLength(); i < j; i++) {
        const layer = layers.item(i);
        const layerName = layer.get("name");
        const whiteList = [
          "draw",
          "highlight",
          "mark",
          "clip",
          "imagery",
          "hidden",
        ];
        if (!whiteList.includes(layerName)) {
          layerList.push({
            id: i + 1,
            layer,
            name: layer.get("name"),
            type: layer.get("type"),
            visible: layer.getVisible(),
          });
        }
      }
      this.layers = layerList;
      this.showLayer = !this.showLayer;
    },

    // 显隐图层
    layerToggle(item) {
      const setVal = !item.layer.getVisible();
      item.layer.setVisible(setVal);
      item.visible = setVal;
    },

    // 显示卷帘
    onShowSwip() {
      this.timeline = this.$refs.olTimeline.current;
      this.showSwip = true;
    },

    // 切换自定义区域
    switchZone(payload) {
      this.zones.forEach((zone) => {
        if (payload.id === zone.id) {
          zone.visible = !zone.visible;
        } else {
          zone.visible = false;
        }
      });
      this.$emit("zoneChange", payload);
    },
  },

  beforeDestroy() {
    // 注销事件
    this.unBindClick();
    this.map = null;
    window.removeEventListener("resize", this.resize);
  },
};
</script>

<style lang="scss" scoped>
.ol-map {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  // position: absolute;
  // top: 0;
  // left: 0;
  // z-index: 2;
  background: #053520;
  .m-t-sm {
    margin-top: 10px;
  }

  .ol-map-tools {
    position: fixed;
    top: 10px;
    right: 3%;
    bottom: 10px;
    display: flex;
    flex-direction: column;
    z-index: 2;
  }

  .ol-map-tool-slot {
    flex: 1;
  }

  .ol-map-tool-group {
    position: relative;
    width: 36px;
    border-radius: 4px;
    border: 1px solid rgba(30, 124, 104, 1);
    backdrop-filter: blur(4px);
    background-color: rgba(4, 54, 35, 0.8);
    box-shadow: 0px 4px 10px 0px rgba(146, 159, 168, 0.4);
  }

  .ol-map-tool {
    position: relative;
    height: 36px;
    line-height: 36px;
    text-align: center;

    &:not(:last-of-type)::after {
      content: "";
      position: absolute;
      left: 5px;
      right: 5px;
      bottom: 0px;
      height: 1px;
      background-color: #004436;
    }
  }

  .ol-map-layers {
    position: absolute;
    top: 0px;
    left: -110px;
    display: flex;
    flex-direction: column;
    width: 100px;
    font-size: 12px;
    padding: 10px 0;
    border: 1px solid rgba(139, 177, 226, 0.4);
    border-radius: 4px;
    backdrop-filter: blur(4px);
    background-color: rgba(10, 23, 39, 0.64);
    box-shadow: 0px 4px 10px 0px rgba(146, 159, 168, 0.4);
    z-index: 2;
  }

  .ol-map-layer {
    line-height: 30px;
    text-align: center;
    color: #666;
    cursor: pointer;

    &.visible {
      color: #afddff;
    }
  }

  .ol-map-dialog {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 55;
  }

  .ol-map-dialog-main {
    .ol-map-dialog-title {
      font-size: 20px;
      margin-left: 20px;
      margin: 10px;
      color: rgba(53, 241, 193, 1);
    }

    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 90%;
    left: 50%;
    width: 75%;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    padding: 0px 10px 10px;
    border: 1px solid rgba(139, 177, 226, 0.4);
    border-radius: 4px;
    box-shadow: 0px 0px 10px 2px rgba(146, 159, 168, 0.4) inset;
    background: url("~@/assets/images/layout/boxbg.png") no-repeat;
    background-size: 100% 100%;
  }

  .close-btn {
    position: absolute;
    top: -17px;
    right: -51px;
    font-size: 41px;
    margin: 0;
    cursor: pointer;
    color: rgb(90, 234, 173);
  }

  .ol-map-switch-basemap {
    position: absolute;
    top: -36px;
    left: -325px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 315px;
    height: 73px;
    color: #afddff;
    font-size: 12px;
    border: 1px solid rgba(139, 177, 226, 0.4);
    border-radius: 4px;
    backdrop-filter: blur(4px);
    background-color: rgba(10, 23, 39, 0.64);
    box-shadow: 0px 4px 10px 0px rgba(146, 159, 168, 0.4);
    z-index: 2;
  }

  .ol-map-basemap {
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 2px;
    overflow: hidden;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 2px;
      pointer-events: none;
    }

    &.active::after {
      border: 2px solid #007ddc;
      background-color: rgba(0, 125, 220, 0) !important;
    }

    &:hover::after {
      background-color: rgba(0, 125, 220, 0.3);
    }
  }

  .ol-map-basemap-img {
    border-radius: 2px;
  }

  .ol-map-basemap-label {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    padding: 0 2px;
    border-top-right-radius: 5px;
    background-color: #007ddc;

    span {
      display: block;
      color: #fff;
      transform: scale(0.8);
    }
  }

  .ol-map-basemap-mark {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .ol-map-basemap-mark-label {
    display: inline-block;
    color: #ccc;
    transform: scale(0.8);

    &.selected {
      color: #fff;
    }
  }

  .ol-map-tool-icon {
    color: #fff;
    font-size: 20px;
    margin: 0;
    cursor: pointer;

    &:hover {
      color: rgba(90, 234, 173, 1);
    }
  }

  .ol-map-mouse-position {
    display: none;
    position: absolute;
    left: 5%;
    bottom: 6%;
    align-items: center;
    width: 160px;
    height: 24px;
    color: #fff;
    font-size: 12px;
    border: 1px solid rgba(30, 124, 104, 1);
    border-radius: 4px;
    backdrop-filter: blur(4px);
    background-color: rgba(4, 54, 35, 0.8);
    box-shadow: 0px 4px 10px 0px rgba(146, 168, 161, 0.4);
    z-index: 2;
  }

  .ol-map-legends {
    position: absolute;
    right: 15px;
    bottom: 50px;
    padding: 10px 10px;
    box-sizing: border-box;
    min-width: 120px;
    font-size: 12px;
    border: 1px solid rgba(30, 124, 104, 1);
    border-radius: 4px;
    backdrop-filter: blur(4px);
    background-color: rgba(4, 54, 35, 0.8);
    box-shadow: 0px 4px 10px 0px rgba(146, 159, 168, 0.4);
    z-index: 2;
  }

  .legendTitle {
    font-size: 16px;
    margin-bottom: 15px;
    text-align: center;
    color: #fff;
  }

  .legendBigBox {
    max-height: 400px;
    overflow-y: auto;
  }

  .ol-map-legend-unit {
    flex: 1;
    text-align: center;
    color: #fff;
  }

  .ol-map-legend-all {
    height: 18px;
    font-size: 14px;
    color: #fff;
    margin-left: 10px;
    padding: 0 5px;
    border-radius: 2px;
    backdrop-filter: blur(4px);
    background-color: rgba(0, 125, 220, 0.8);
    cursor: pointer;
  }

  .ol-map-legend-toggle {
    margin-right: 0;
  }

  .ol-map-legend {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    // cursor: pointer;
    padding-left: 10px;
  }

  .ol-map-legend-icon {
    width: 20px;
    height: 20px;
    margin-right: 13px;
    border-radius: 1px;
  }

  .iconUrl {
    width: 30px;
    height: 30px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .ol-map-legend-label {
    color: #fff;
  }

  .screen-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    background-color: rgba(10, 23, 39, 0.5);
    z-index: 999;

    .screen-operate {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }

  .crop-images {
    position: absolute;
    top: 0px;
    left: -242px;
    display: flex;
    flex-direction: column;
    width: 232px;
    height: 300px;
    padding-bottom: 10px;
    font-size: 12px;
    border: 1px solid rgba(139, 177, 226, 0.4);
    border-radius: 4px;
    backdrop-filter: blur(4px);
    background-color: rgba(10, 23, 39, 0.64);
    box-shadow: 0px 4px 10px 0px rgba(146, 159, 168, 0.4);
    z-index: 2;

    .crop-image-title {
      flex-basis: 40px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #fff;
      padding: 0 10px;
    }

    .crop-image-box {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      padding: 0 5px;
      overflow: hidden;
    }

    .crop-image-item {
      position: relative;
      margin: 5px;
      overflow: hidden;
    }

    .crop-image {
      display: block;
      width: 100px;
      height: 100px;
      border-radius: 6px;
    }

    .remove-image {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>
